module.exports = __webpack_public_path__ + "media/images/icons/dashboard-d10c6e38d80657d45a7adf9de688117a.svg";